import { Lightning } from '@lightningjs/sdk';
import _merge from 'lodash/merge';
import { DARK_MODE } from '@tornado-rdk/theme';
import { identity } from '../../tornado/utils/sizes';
import { Button } from '../../tornado/button/button.component';
import { t } from '../../i18n';
import { getInitialStyle, getFinalStyle } from './exitPopup.style';
import { EXIT_APP_SIGNAL, HIDE_POPUP_SIGNAL } from '../../popupContainer/popupContainer.constants';
import Icon from '../../tornado/icon/icon.component';
import { ButtonRectangle } from '../../tornado/callToAction/background/buttonRectangle.component';

export class ExitPopup extends Lightning.Component {
  static _template() {
    return _merge(
      {
        w: identity,
        h: identity,
        Overlay: {},
        Popup: {
          type: ButtonRectangle,
          Icon: {
            type: Icon,
          },
          Title: {
            text: {
              text: t('global.confirmExit'),
            },
          },
          ButtonsFlexContainer: {
            ExitButton: {
              type: Button,
              label: t('global.ok'),
              colorMode: DARK_MODE,
            },
            CancelButton: {
              type: Button,
              label: t('global.cancel'),
              colorMode: DARK_MODE,
            },
          },
        },
        passSignals: {
          [EXIT_APP_SIGNAL]: true,
          [HIDE_POPUP_SIGNAL]: true,
        },
      },
      getInitialStyle(),
    );
  }

  _attach() {
    const icon = this.tag('Popup').tag('Icon');

    const handleUpdate = () => {
      this.patch({ ...getFinalStyle() });
    };

    icon.on('txLoaded', handleUpdate);
  }

  _detach() {
    this.tag('Popup').tag('Icon').removeAllListeners('txLoaded');
  }

  _build() {
    this._index = 0;
    this._actionTypes = [EXIT_APP_SIGNAL, HIDE_POPUP_SIGNAL];
    this._buttons = this.tag('Popup').tag('ButtonsFlexContainer').children;
  }

  _getFocused() {
    return this._buttons[this._index];
  }

  _handleRight() {
    if (this._index < this._buttons.length - 1) {
      this._setIndex(this._index + 1);

      return true;
    }

    return false;
  }

  _handleLeft() {
    if (this._index > 0) {
      this._setIndex(this._index - 1);

      return true;
    }

    return true;
  }

  _handleEnter() {
    this.signal(this._actionTypes[this._index]);
  }

  _setIndex(index = this._index) {
    this._index = index;
  }
}
